import React from 'react';
import { Search, Mic } from 'lucide-react';

interface Props { api: any; compact?: boolean; }

export default function SearchBar({ api, compact }: Props) {
  return (
    <div 
      onClick={() => api.setShowSuggestions(true)}
      className="relative flex-1 flex flex-row items-center gap-2 w-full max-w-2xl mx-auto cursor-pointer group"
    >
      <div className="relative flex-1 w-full flex items-center bg-neutral-50 dark:bg-neutral-900 rounded-full border border-neutral-200/80 dark:border-white/10 group-hover:border-primary/50 dark:group-hover:border-primary/50 transition-all shadow-[0_2px_10px_rgba(0,0,0,0.03)] py-2.5 px-4">
        <span className="text-primary dark:text-pink-400 mr-2 shrink-0">
          <Search className="w-4.5 h-4.5 stroke-[2.5px]" />
        </span>
        <span className="text-[14px] text-neutral-400 dark:text-neutral-500 font-bold select-none truncate">
          {api.searchQuery || (api.lang === 'en' ? 'Search Products...' : 'প্রোডাক্টস খুঁজুন...')}
        </span>
        <div className="ml-auto flex items-center shrink-0 pl-2">
          <Mic className="w-4 h-4 text-primary dark:text-pink-400 stroke-[2.5px]" />
        </div>
      </div>
      {!compact && (
        <button 
          type="button"
          className="hidden sm:flex shrink-0 items-center gap-1.5 px-6 py-3 rounded-full bg-gradient-to-r from-primary to-secondary text-white hover:opacity-95 active:scale-95 transition-all whitespace-nowrap shadow-[0_4px_16px_rgba(var(--theme-rgb),0.3)]"
        >
          <Search className="w-4 h-4 stroke-[2.5px]" />
          <span className="text-[13px] font-black uppercase tracking-wider">{api.lang === 'en' ? 'Search' : 'সার্চ'}</span>
        </button>
      )}
    </div>
  );
}

